<div class="flex justify-center items-center py-32 gap-4">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-mint"></div>
    <div>Logging Out</div>
</div>